import clsx from "clsx";
import type { ComponentProps } from "react";

import { ButtonWithIcon } from "@shared/ui/button-with-icon";
import { RuleCard } from "@shared/ui/rule-card";
import { Heading } from "@shared/ui/typography";
import { mod } from "@shared/utils";

import type { RulesType } from "../model";

import s from "./rules-section.module.scss";

export type RulesSectionProps = ComponentProps<"div"> & {
  className?: string;
  data: RulesType;
  variant?: "violet" | "milk";
};

export const RulesSection = (props: RulesSectionProps) => {
  const { className, data, variant = "violet" } = props;

  const mods = mod(s, { variant });

  const style: React.CSSProperties & { ["--columns"]: string } = {
    "--columns": data?.rules?.length.toString() || "2",
  };

  return (
    <section className={clsx(s.root, mods, className)} style={style}>
      {data?.title && (
        <Heading level={3} className={s.title}>
          {data.title}
        </Heading>
      )}
      <div className={s.cards}>
        {data?.rules?.length > 0 &&
          data.rules.map((card) => (
            <RuleCard key={card?.title ?? card?.documentId} data={card} />
          ))}
      </div>
      {data?.button && (
        <ButtonWithIcon
          href={data?.button?.link}
          iconName={data?.button?.pageIcon?.icon?.name || "plus"}
          iconFillColor={data?.button?.pageIcon?.fillColor || "azure"}
          iconStrokeColor={data?.button?.pageIcon?.strokeColor || "white"}
          iconSvgCode={data?.button?.pageIcon?.uicon?.svg_code}
          className={s.button}
        >
          {data?.button?.text}
        </ButtonWithIcon>
      )}
    </section>
  );
};

RulesSection.displayName = "RulesSection";
